import { useState } from "react";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import CloseIcon from '../Icons/CloseIcon';
import './styles.css';
import MainBtn from '../../components/MainBtn';
import StyledDropzone from '../StyledDropzone';
import { useUploadBudgetFileRequest } from "../../hooks/useApi";
import { getEnv } from "../../utils/env";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: "10px",
  boxShadow: 24,
  pt: 2,
  pb: 3,
};

export default function UploadBudgetModal({ open, setOpenModal, handleClose, onSuccess }) {
  const [ { loading: loadingFile}, uploadBudgetFile ] = useUploadBudgetFileRequest();
  const [files, setFiles] = useState([]);
  const [uploadStatus, setUploadStatus] = useState(null);
  const uploadBudgetHandleClick = async (event) => {
    if (files.length <= 0)
      return false;
    const bodyParams = {};
    const fileParams = files;

    const response = await uploadBudgetFile({ bodyParams, fileParams });
    if (response.status == 200)
    {
      setUploadStatus('success');
      setFiles([]);
      handleClose();
      onSuccess();
    }
    else
      setUploadStatus('error')
  }

  const statusText = (uploadStatus) => {
    if (uploadStatus == 'success')
      return (<>File uploaded successfully.</>);
    else if (uploadStatus == 'error')
      return (<>Failed to upload the file.</>);
    else
      return (<></>);
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box id="uploadKpiModal" sx={{ ...style, width: 720, maxHeight: 821 }}>
          <div className="modalTitle dFlex justifyContentSpaceBetween">
            <div>
              <h2 className="">Upload Budget file</h2>
              <p className="subTitle">You can upload one file at a time</p>
              <p className="info"><a href={getEnv('BUDGET_IMPORT_TEMPLATE_URL')}>Download</a> a example of excel file.</p>
            </div>
            <a className='close' onClick={handleClose}>
              <CloseIcon />
            </a>
          </div>
          <hr/>
          <div className="modalBody">
            <StyledDropzone files={files} setFiles={setFiles} loading={loadingFile} />
            {!loadingFile && (<div className="responseText">{statusText(uploadStatus)}</div>)}
          </div>
          <hr/>
          <div className="modalFooter">
            <div className="flex place-content-end">
              <div className="flex place-content-between alignItemsCenter">
                <a className="footerCancel" onClick={handleClose}>Cancel</a>
                <MainBtn title="Upload" onClick={uploadBudgetHandleClick} />
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}